import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';
import BtnExcel from '../../Components/BtnExcel';

import { 
  Layout,
  Col, 
  Row,
  Button,
  Dropdown, 
  Space,
  Modal,
  Form,
  InputNumber,
  Input,
} from 'antd';
import { formatDate, getTodayDateISO } from '../../Utils/Common';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { Item } = Form;
const { Search } = Input;
const { confirm } = Modal;

const BillingItems = () => {
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [billingItemId, setBillingItemId] = useState('');
  const [excelData, setExcelData] = useState([])
  const [billingItemData, setBillingItemData] = useState([])
  const [addBillingItemForm] = Form.useForm();
  const [editBillingItemForm] = Form.useForm();

  const [filterConfig, setFilterConfig] = useState({
    billing_item_id: '',
    description: '',
    search: '',
    page: 1,
  })

  const { callPost, loading } = usePostRequest(()=>{
    fetchTableData()
    addBillingItemForm.resetFields();
    editBillingItemForm.resetFields();
    setAddVisible(false); 
    setEditVisible(false);
  });

  function ActionBtn(row) {
    const items = [
      {
        label: (
          <div onClick={() => showEditModal(row.row)}>
            Edit
          </div>
        ),
        key: '2',
    },
      {
        label: (
          <div style={{color: 'red'}} onClick={() => showDeleteConfirm(row.row.id)}>
            Delete
          </div>
        ),
        key: '3',
      },
    ];

    return (
      <span className='center'>
        <Dropdown
          menu={{
          items,
          }}
          trigger={['click']}
        >
          <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
            <Space>
              <MoreVert />
            </Space>
          </div>
        </Dropdown>
      </span>
    );
  }

  async function fetchTableData  () {
    setIsLoading(true);
    const response = await UseGetRequest("billing_items/get", filterConfig);
    if (response.data) {
      setBillingItemData(response.data.data);
      setPageSize(response?.data?.size)
    } else {
      setBillingItemData([])
      setPageSize('')
    }
    setIsLoading(false);
  }

  async function fetchExportData  () {
    setExportLoading(true);
    const response = await UseGetRequest("billing_items/get", 
      {
        billing_item_id: filterConfig.billing_item_id,
        description: filterConfig.description,
      }
    );
    if (response.data) {
      const excel_data = response?.data?.data?.map((data) => ({
        id: data.id,
        description: data.description,
        vat: data.vat,
        withholding_tax: data.withholding_tax,
        added_on: data.added_on && formatDate(data.added_on),
        updated_on: data.updated_on && formatDate(data.updated_on),
      }))

      setExcelData(excel_data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  const handleAddOk = () => {
    addBillingItemForm.validateFields().then(values => {
      const reset_data = {
        description: values.description,
        vat: values.vat || "0.00",
        withholding_tax: values.withholding_tax || "0.00"
      }
      callPost(
        "billing_items/create", 
        reset_data,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleEditOk = () => {
    editBillingItemForm.validateFields().then(values => {
      const reset_data = {
        description: values.description,
        vat: values.vat || "0.00",
        withholding_tax: values.withholding_tax || "0.00"
      }
      callPost(
        "billing_items/update", 
        {
          billing_item_id: billingItemId,
          ...reset_data
        },
        false
      );        
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Are you sure delete this Billing Item?',
      icon: <ExclamationCircleFilled />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      confirmLoading: loading,
      onOk() {
        callPost(
          "billing_items/delete", 
          {billing_item_id: id},
          false
        );
      },
    });
  };

  const showAddModal = () => {
    setAddVisible(true);
  };

  const showEditModal = (billing_item) => {
    setEditVisible(true);
    setBillingItemId(billing_item.id)
    editBillingItemForm.setFieldsValue({
      description: billing_item.description,
      vat: billing_item.vat,
      withholding_tax: billing_item.withholding_tax,
    });
  };

  const handleAddCancel = () => {
    setAddVisible(false);
  };

  const handleEditCancel = () => {
    setEditVisible(false);
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        description: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          description: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchTableData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'billing_items_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={12} className='header-container'>
              BILLING ITEM
          </Col>
          <Col span={12}  className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "ID",
                  "Description",
                  "Vat",
                  "Withholding Tax",
                  "Added On",
                  "Updated On",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Billing_Item_${getTodayDateISO()}.xlsx`}
              />            
              <Button 
                className='button-color responsive-btn-two' 
                onClick={showAddModal} 
                type="primary"
              >
                + Add Billing Item
              </Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Space span={24} className='responsive-inline excel-row'>
            <Search
              placeholder="Search..."
              size='medium'
              onSearch={(e)=>handleSearchChange(e)}
              onChange={(e)=>handleEmpty(e)}
              className='responsive-header-input'
            />              
          </Space>
        </Row>
        <Row className='page-content'>
          <Col span={24}>
            <AntDTable
              tableHeaders={[
                "Description",
                "VAT",
                "Witholding Tax",
              ]}
              headerSelector={[
                "description",
                "vat",
                "withholding_tax",
              ]}
              tableData={billingItemData}
              ActionBtn={(row) => ActionBtn(row)}
              withAction={true}
              loading={isLoading}
              tablePages={10}
              handleTableChange={handleTableChange}
              filterConfig={filterConfig}
              totalSize={pageSize}
              isSearch={true}
            />
          </Col>
        </Row>
      </Layout>
      <Modal
        title="Add Billings"
        open={addVisible}
        confirmLoading={loading}
        onOk={handleAddOk}
        okText="Submit"
        onCancel={handleAddCancel}
      >
        <Form 
          form={addBillingItemForm} 
          layout="vertical" 
        >
          <Item
            label="Description"
            name="description"
            rules={[{ required: true, message: 'Please enter your Description!' }]}
          >
            <Input />
          </Item>
          <Item
            label="VAT"
            name="vat"
            // rules={[{ required: true, message: 'Please enter your VAT!' }]}
          >
            <InputNumber   style={{width:'100%'}}/>
          </Item>
          <Item
            className='mb-4'
            label="Witholding Tax(%)"
            name="withholding_tax"
            // rules={[{ required: true, message: 'Please enter your Witholding Tax(%)!' }]}
          >
            <InputNumber   style={{width:'100%'}}/>
          </Item>
        </Form>
      </Modal>
      <Modal
        title="Edit Billings"
        open={editVisible}
        confirmLoading={loading}
        onOk={handleEditOk}
        okText="Save"
        onCancel={handleEditCancel}
      >
        <Form form={editBillingItemForm} layout="vertical">
          <Item
            label="Description"
            name="description"
            rules={[{ required: true, message: 'Please enter your Description!' }]}
          >
            <Input />
          </Item>
          <Item
            label="VAT"
            name="vat"
            // rules={[{ required: true, message: 'Please enter your VAT!' }]}
          >
            <InputNumber   style={{width:'100%'}}/>
          </Item>
          <Item
            className='mb-4'
            label="Witholding Tax(%)"
            name="withholding_tax"
            // rules={[{ required: true, message: 'Please enter your Witholding Tax(%)!' }]}
          >
            <InputNumber   style={{width:'100%'}}/>
          </Item>
        </Form>
      </Modal>
    </Layout>
  )
}

export default BillingItems
